export function addDaysToDate(date: Date, days: number): Date {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    throw new Error("Invalid date provided.");
  }

  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);

  return newDate;
}

export const resetDateToMidnight = (date: Date) => {
  const resetDate = new Date(date);
  resetDate.setHours(0, 0, 0, 0);
  return resetDate;
};
